import React, { useEffect, useState } from "react";
import { X, Phone, Video, Search, Bell, Lock, Archive, Trash2, UserPlus, Edit3 } from "lucide-react";
import { display } from "@mui/system";
import { useAPI } from "../Context/MyContext";
import toast from "react-hot-toast";
;

const ContactInfoPanel = ({ contact, messageID, number, isOpen, onClose, phoneId, onAddContact }) => {

  // console.log("Contact Info Panel - contact:", contact);

  // const displayName = contact.name || number;

  const [isEditing, setIsEditing] = useState(false);
  const [editName, setEditName] = useState(contact?.name || "");
  const [editPhone, setEditPhone] = useState(number || contact?.recipientId || "");
  const { createContact, updateContact, getNumberInfo, blockUser, checkBlockedUser, deleteBlockedUser, getAllowedUserFeatures } = useAPI();
  const [existingContactId, setExistingContactId] = useState(null);
  const [refreshKey, setRefreshKey] = useState(0);

  // const displayName = isEditing ? editName || number : contact.name || number;
  const displayName = editName || editPhone;

  const [isSaving, setIsSaving] = useState(false);
  const [isDirty, setIsDirty] = useState(false);


  const [isBlocked, setIsBlocked] = useState(false);
  const [isCheckingBlock, setIsCheckingBlock] = useState(false);
  const [isBlockLoading, setIsBlockLoading] = useState(false);
  const [isAllowedToEdit, setIsAllowedToEdit] = useState(false);




  useEffect(() => {
    const fetchUser = async () => {
      try {
        const data = await getAllowedUserFeatures();

        if (data.permissions?.viewCustomerName === true) {
          setIsAllowedToEdit(true);
        }

        console.log("Allowed user features:", data);
      } catch (error) {
        console.error("Failed to load profile:", error);
      }
    };
    fetchUser();
  }, []);


  useEffect(() => {
    setEditName(contact?.name || "");
    setEditPhone(number || contact?.recipientId || "");
    setIsEditing(false);
    setIsDirty(false);
  }, [contact, number]);





  useEffect(() => {
    if (!isOpen || !number) return;

    let isMounted = true;

    const fetchContactInfo = async () => {
      try {
        // const response = await getNumberInfo(number);
        const response = await getNumberInfo(messageID);

        if (!isMounted) return;

        if (response?.success && response?.data) {
          const data = response.data;

          setExistingContactId(data._id || null);

          setEditName(data.name || "");
          setEditPhone(data.phone || number);

          if (Array.isArray(data.attribute) && data.attribute.length > 0) {
            setAttributes(
              data.attribute.map(attr => ({
                key: attr.key || "",
                value: attr.value || ""
              }))
            );
          } else {
            setAttributes([{ key: "", value: "" }]);
          }
        } else {
          // If not found
          setExistingContactId(null);
          setAttributes([{ key: "", value: "" }]);
        }
      } catch (error) {
        console.error("Failed to fetch number info:", error);
      }
    };

    fetchContactInfo();

    return () => {
      isMounted = false;
    };
  }, [isOpen, number, refreshKey, getNumberInfo]);


  useEffect(() => {
    if (!isOpen || !number || !phoneId) return;

    let mounted = true;

    const checkStatus = async () => {
      try {
        setIsCheckingBlock(true);

        const res = await checkBlockedUser({
          phoneNumberId: phoneId,
          phone: number,
        });

        if (mounted && res?.success) {
          setIsBlocked(res.isBlocked);
        }
      } catch (err) {
        console.error("Block check failed:", err);
      } finally {
        if (mounted) setIsCheckingBlock(false);
      }
    };

    checkStatus();

    return () => {
      mounted = false;
    };
  }, [isOpen, number, phoneId]);




  // const isContactSaved =
  //   contact.name && contact.name !== contact.recipientId;

  const [attributes, setAttributes] = useState([
    { key: "", value: "" }
  ]);

  const handleAttributeChange = (index, field, value) => {
    const updated = [...attributes];
    updated[index][field] = value;
    setAttributes(updated);
    setIsDirty(true);
  };

  const addAttribute = () => {

    setAttributes([...attributes, { key: "", value: "" }]);
    setIsDirty(true);
  };

  const removeAttribute = (index) => {
    setAttributes(attributes.filter((_, i) => i !== index));
    setIsDirty(true);
  };

  const handlePanelClose = () => {
    setIsEditing(false);
    setIsDirty(false);
    setEditName(contact?.name || "");
    setEditPhone(number || contact?.recipientId || "");
    onClose();
  };


  const handleSaveContact = async () => {
    if (!editPhone || isSaving) return;

    setIsSaving(true);

    const payload = {
      name: editName?.trim() || "",
      phone: editPhone.trim(),
      attribute: attributes
        .filter(a => a.key.trim() && a.value.trim())
        .map(a => ({
          key: a.key.trim().toLowerCase(),
          value: a.value.trim()
        }))
    };

    try {
      let contactData;

      if (existingContactId) {
        const updated = await updateContact(existingContactId, payload);

        if (updated?.success) {
          contactData = updated.data;
          toast.success(updated.message || "Contact updated successfully");
        }
      } else {
        const created = await createContact({ contact: payload });

        if (created?.success) {
          toast.success("Contact added successfully");
        }

        if (created?.data?.length > 0) {
          contactData = created.data[0];
          setExistingContactId(contactData._id);
        }
      }

      if (contactData) {
        setEditName(contactData.name || "");
        setEditPhone(contactData.phone || "");
        setAttributes(contactData.attribute || []);
      }

      setIsDirty(false);
      setIsEditing(false);
    } catch (error) {
      console.error("Save failed:", error);
      toast.error("Something went wrong");
    } finally {
      setIsSaving(false);
    }
  };


  // const handleBlockUser = async () => {
  //   if (!contact?.phone && !number) return; // no valid phone
  //   if (isSaving) return; // prevent duplicate calls

  //   setIsSaving(true);

  //   try {
  //     const phoneToBlock = contact.phone || number;

  //     const payload = {
  //       phoneNumberId: phoneId, // or phoneId if required
  //       phone: phoneToBlock,
  //     }

  //     // Call the optimized helper
  //     const res = await blockUser(payload);

  //     if (res.success) {
  //       toast.success(`${displayName} blocked successfully!`);

  //       // Update local attributes safely
  //       setAttributes(prev => {
  //         // Avoid duplicate blocked attribute
  //         if (!prev.some(attr => attr.key === "blocked")) {
  //           return [...prev, { key: "blocked", value: true }];
  //         }
  //         return prev;
  //       });
  //     } else {
  //       toast.error(res.message || "Failed to block user");
  //     }
  //   } catch (err) {
  //     console.error("Block user failed:", err.message || err);
  //     toast.error("Something went wrong while blocking user");
  //   } finally {
  //     setIsSaving(false);
  //   }
  // };

  const handleToggleBlock = async () => {
    if (!number || isBlockLoading) return;

    try {
      setIsBlockLoading(true);

      if (isBlocked) {
        // UNBLOCK
        const res = await deleteBlockedUser({
          phoneNumberId: phoneId,
          phone: number,
        });

        if (res?.success) {
          setIsBlocked(false);
          toast.success(`${displayName} unblocked`);
        } else {
          toast.error(res.message || "Failed to unblock");
        }
      } else {
        // BLOCK
        const res = await blockUser({
          phoneNumberId: phoneId,
          phone: number,
        });

        if (res?.success) {
          setIsBlocked(true);
          toast.success(`${displayName} blocked`);
        } else {
          toast.error(res.message || "Failed to block");
        }
      }
    } catch (err) {
      console.error("Toggle block failed:", err);
      toast.error("Something went wrong");
    } finally {
      setIsBlockLoading(false);
    }
  };


  return (
    <>
      {/* Overlay backdrop */}
      <div
        className={`fixed inset-0 bg-black transition-opacity duration-300 z-[200] ${isOpen ? "opacity-50" : "opacity-0 pointer-events-none"
          }`}
        onClick={handlePanelClose}
      />

      {/* Side panel */}
      <div
        className={`fixed top-0 right-0 h-full w-full md:w-[440px] bg-white shadow-2xl transform transition-transform duration-300 ease-in-out z-[250] ${isOpen ? "translate-x-0" : "translate-x-full"
          }`}
      >
        {/* Header */}
        <div className="bg-[#008069] text-white p-4 flex items-center">
          <button
            onClick={handlePanelClose}
            className="mr-4 hover:bg-white/10 p-2 rounded-full transition-colors"
            aria-label="Close panel"
          >
            <X size={24} />
          </button>
          <h2 className="text-lg font-medium">Contact info</h2>
        </div>

        {/* Scrollable content */}
        <div className="overflow-y-auto overflow-x-hidden h-[calc(100%-64px)]">
          {/* Profile Section */}
          <div className="bg-[#f0f2f5] py-8 flex flex-col items-center relative">

            {/* Avatar */}
            <div className="relative mb-4">
              <img
                src={
                  contact.image ||
                  `https://ui-avatars.com/api/?name=${encodeURIComponent(
                    displayName
                  )}&background=random&size=200`
                }
                alt={displayName}
                className="w-32 h-32 rounded-full object-cover"
              />
            </div>

            {/* ✏️ EDIT BUTTON  */}
            {!isEditing && (
              <button
                onClick={() => setIsEditing(true)}
                title="Edit contact"
                className="absolute right-4 bg-white border border-gray-200 p-3 rounded-full shadow-md hover:shadow-lg hover:bg-gray-50 transition"
              >
                <Edit3 size={18} className="text-gray-700" />
              </button>
            )}
            {/* 🔙 BACK BUTTON (ONLY SHOW IN EDIT MODE) */}
            {isEditing && (
              <button
                onClick={() => setIsEditing(false)}
                title="Back to profile"
                className="absolute left-4 bg-white border border-gray-200 p-3 rounded-full shadow-md hover:shadow-lg hover:bg-gray-50 transition"
              >
                <X size={18} className="text-gray-700" />
              </button>
            )}


            {/* 🔙 BACK BUTTON (ONLY SHOW IN EDIT MODE) */}
            {isEditing && (
              <button
                onClick={() => setIsEditing(false)}
                title="Back to profile"
                className="absolute left-4 bg-white border border-gray-200 p-3 rounded-full shadow-md hover:shadow-lg hover:bg-gray-50 transition"
              >
                <X size={18} className="text-gray-700" />
              </button>
            )}


            {/*  TOGGLE CONTENT */}
            <div className="w-full px-6 relative" style={{ minHeight: '120px' }}>

              {/* VIEW MODE */}
              <div
                className={`transition-all duration-500 ease-in-out ${!isEditing
                  ? 'opacity-100 translate-y-0 relative'
                  : 'opacity-0 -translate-y-4 absolute inset-0 pointer-events-none'
                  }`}
              >
                <h3 className="text-2xl font-semibold text-gray-900 text-center">
                  {displayName}
                </h3>


                {editName && displayName !== editPhone && (
                  <p className="text-lg text-gray-600 mt-1 text-center">
                    {editPhone}
                  </p>
                )}


                {/* <p className="text-sm text-gray-500 mt-1 text-center">
                  ~ WhatsApp user
                </p> */}
              </div>

              {/* EDIT MODE */}
              <div
                className={`transition-all duration-500 ease-in-out ${isEditing
                  ? 'opacity-100 translate-y-0 relative'
                  : 'opacity-0 translate-y-4 absolute inset-0 pointer-events-none'
                  }`}
              >
                <div className="w-full max-w-sm mx-auto mt-3 space-y-3">
                  {/* IF NOT HAVE PERMISSION SHOW TOL TIP THAT YOU NOT ALLOWED TO EDIT ON HOVER */}
                  {/* <input
                    type="text"
                    value={editName}
                    onChange={(e) => {
                      setEditName(e.target.value);
                      setIsDirty(true);
                    }}
                    placeholder="Contact name"
                    className="w-full border border-gray-300 rounded-md px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-[#008069] "
                  /> */}

                  <div className="relative group w-full">
                    <input
                      type="text"
                      value={editName}
                      disabled={!isAllowedToEdit}
                      onChange={(e) => {
                        setEditName(e.target.value);
                        setIsDirty(true);
                      }}
                      placeholder="Contact name"
                      className={`w-full border border-gray-300 rounded-md px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-[#008069] disabled:bg-gray-100  ${!isAllowedToEdit ? "cursor-not-allowed" : ""}`}
                    />

                    {!isAllowedToEdit && (
                      <div className="absolute left-0 -top-8 opacity-0 group-hover:opacity-100 transition bg-black text-white text-xs px-2 py-1 rounded">
                        You are not allowed to edit
                      </div>
                    )}
                  </div>
                  {/* not editable input */}
                  <div className="relative group">
                    <input
                      type="text"
                      value={editPhone}
                      readOnly
                      placeholder="Phone number"
                      className="w-full border border-gray-300 rounded-md px-3 py-2 text-sm 
               bg-gray-50 cursor-not-allowed
               group-hover:bg-gray-100
               transition-all"
                    />

                    {/* Hover Indicator */}
                    <div className="absolute right-3 top-1/2 -translate-y-1/2 
                  flex items-center gap-1 opacity-0 
                  group-hover:opacity-100 transition">
                      <span className="text-xs text-gray-500">Not editable</span>
                      <Lock size={14} className="text-gray-400" />
                    </div>
                  </div>



                </div>
              </div>

            </div>
          </div>

          {/* Attributes Section */}
          <div className="bg-white mb-2">
            <div className="px-4 py-3 border-b">
              <div className="flex items-center justify-between mb-3">
                <p className="text-sm text-gray-600 font-medium">Add Attributes</p>

                {isEditing && (
                  <button
                    onClick={addAttribute}
                    className="text-xs text-[#008069] font-medium hover:underline"
                  >
                    + Add
                  </button>
                )}

              </div>

              <div className="space-y-3">
                {attributes.map((attr, index) => (
                  <div
                    key={index}
                    className={`grid gap-2 items-center transition-all
                    ${isEditing
                        ? "grid-cols-[minmax(0,1fr)_minmax(0,1fr)_28px]"
                        : "grid-cols-2"
                      }`}
                  >

                    <input
                      type="text"
                      placeholder="Key"
                      value={attr.key}
                      onChange={(e) =>
                        handleAttributeChange(index, "key", e.target.value)
                      }
                      disabled={!isEditing}
                      className={`border border-gray-300 rounded-md px-2 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-[#008069]
    ${!isEditing ? "bg-gray-50 cursor-not-allowed" : ""}`}
                    />

                    <input
                      type="text"
                      placeholder="Value"
                      value={attr.value}
                      onChange={(e) =>
                        handleAttributeChange(index, "value", e.target.value)
                      }
                      disabled={!isEditing}
                      className={`border border-gray-300 rounded-md px-2 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-[#008069]
    ${!isEditing ? "bg-gray-50 cursor-not-allowed" : ""}`}

                    />

                    {isEditing && (
                      <button
                        onClick={() => removeAttribute(index)}
                        className="h-8 w-8 flex items-center justify-center rounded-full 
      text-gray-400 transition hover:text-red-600 hover:bg-red-50"
                        title="Delete"
                      >
                        ✕
                      </button>
                    )}


                  </div>
                ))}
              </div>

              {/* SHOW SAVE BUTTON WHEN ATTRIBUTES CHANGED OR NAME IS EDITED */}
              {isEditing && isDirty && (
                <div className="mt-4 flex justify-end">
                  <button
                    onClick={handleSaveContact}
                    disabled={isSaving}
                    className={`px-6 py-2 rounded-md shadow transition-colors
        ${isSaving
                        ? "bg-gray-400 cursor-not-allowed"
                        : "bg-[#008069] hover:bg-[#006e55] text-white"
                      }`}
                  >
                    {isSaving ? (
                      <span className="flex items-center gap-2">
                        <span className="w-4 h-4 border-2 border-white border-t-transparent rounded-full animate-spin"></span>
                        Saving...
                      </span>
                    ) : (
                      "Save"
                    )}
                  </button>
                </div>
              )}

            </div>
          </div>


          {/* Options Section */}
          <div className="bg-white mb-2">

          </div>

          {/* Danger Zone */}
          <div className="bg-white mb-2">
            <button className="w-full px-4 py-3 flex items-center hover:bg-gray-50 transition-colors border-b text-red-600">
              <Trash2 size={20} className="mr-4" />
              <p>Clear chat</p>
            </button>


          </div>

          {/* Block Section */}
          {/* <div className="bg-white mb-4">
            <button className="w-full px-4 py-4 flex items-center justify-center hover:bg-gray-50 transition-colors text-red-600">
              <p className="font-medium">Block {displayName}</p>
            </button>
          </div> */}



          {/* Block Section */}

          <div className="bg-white mb-4">
            <button
              onClick={handleToggleBlock}
              disabled={isBlockLoading || isCheckingBlock}
              className={`w-full px-4 py-4 flex items-center justify-center 
      transition-colors font-medium rounded-md border
      ${isBlocked
                  ? "text-green-600 hover:bg-green-50"
                  : "text-red-600 hover:bg-red-50"
                }
    `}
            >
              {isCheckingBlock ? (
                <span className="flex items-center gap-2">
                  <span className="w-4 h-4 border-2 border-gray-400 border-t-transparent rounded-full animate-spin"></span>
                  Checking...
                </span>
              ) : isBlockLoading ? (
                <span className="flex items-center gap-2">
                  <span className="w-4 h-4 border-2 border-current border-t-transparent rounded-full animate-spin"></span>
                  Processing...
                </span>
              ) : isBlocked ? (
                `Unblock ${displayName}`
              ) : (
                `Block ${displayName}`
              )}
            </button>
          </div>


        </div>
      </div>
    </>
  );
};

export default ContactInfoPanel;